/**
 * @generated SignedSource<<eadaf618c237167e5ada66f0e840aa98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
export type processDefinitionsQueryStatusMutation$variables = {
  ids: ReadonlyArray<string>;
  status: Status;
};
export type processDefinitionsQueryStatusMutation$data = {
  readonly changeProcessDefinitionStatus: boolean | null | undefined;
};
export type processDefinitionsQueryStatusMutation = {
  response: processDefinitionsQueryStatusMutation$data;
  variables: processDefinitionsQueryStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "kind": "ScalarField",
    "name": "changeProcessDefinitionStatus",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionsQueryStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionsQueryStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6f082f49f24b0106ca2bb4a4f869546d",
    "id": null,
    "metadata": {},
    "name": "processDefinitionsQueryStatusMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionsQueryStatusMutation(\n  $ids: [ID!]!\n  $status: Status!\n) {\n  changeProcessDefinitionStatus(ids: $ids, status: $status)\n}\n"
  }
};
})();

(node as any).hash = "e65188bd4bb35cd10ee61629b40f11ec";

export default node;
